import {Box, Fab, Tooltip} from '@mui/material';

import chatbotIconSvg from 'img/chatbot-icon.svg';

import useChatbot from '../../hooks/providers/useChatbot';
import usePayment from '../../hooks/providers/usePayment';

// eslint-disable-next-line react/prop-types
const FabContainer = ({disabled, ...props}) => {
  const WrapperComponent = disabled ? Tooltip : Box;
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <WrapperComponent {...props} />;
};

const ChatbotWidget = () => {
  const {hasTrialEnded, paidFeaturesDisabled} = usePayment();
  const {setChatbotSidebarOpen, isChatbotFeatureDisabled, chatbotDataLoading} = useChatbot();
  const disabled = isChatbotFeatureDisabled || chatbotDataLoading || hasTrialEnded || paidFeaturesDisabled;

  const getDisabledTooltip = () => {
    if (!disabled || chatbotDataLoading) return '';

    if (isChatbotFeatureDisabled) return 'Contactez-nous pour activer SerenIA';

    if (paidFeaturesDisabled) return 'Veuillez choisir un abonnement pour utiliser cette fonctionnalité';

    if (hasTrialEnded) return "Période d'essai terminé. Veuillez choisir un abonnement.";

    return '';
  };

  return (
    <FabContainer disabled={disabled} title={getDisabledTooltip()} placement="left">
      <div>
        <Fab disabled={disabled} color="secondary" onClick={() => setChatbotSidebarOpen(true)}>
          <img alt="chatbot icon" src={chatbotIconSvg} style={{maxWidth: '60%'}} />
        </Fab>
      </div>
    </FabContainer>
  );
};

export default ChatbotWidget;
